import { X } from 'lucide-react';

import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal
} from '@/components/ui/dialog';

interface ImageLightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  alt?: string;
}

/**
 * 共用的圖片 lightbox：點擊縮圖後全螢幕檢視原始尺寸。
 * 給 Markdown.tsx 的 img renderer 與 Elements/Image.tsx 共用，
 * 集中管理樣式，避免行為分歧。
 */
export function ImageLightbox({
  open,
  onOpenChange,
  src,
  alt
}: ImageLightboxProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="bg-black/80" />
        <DialogContent className="border-none bg-transparent shadow-none max-w-none p-0 max-h-screen overflow-auto [&>button]:hidden">
          <div className="relative w-full h-full flex items-center justify-center">
            <button
              onClick={() => onOpenChange(false)}
              className="absolute top-4 right-4 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white z-10"
              aria-label="Close lightbox"
            >
              <X className="h-6 w-6" />
            </button>

            <img
              src={src}
              alt={alt}
              className="max-w-[90vw] max-h-[90vh] object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
